import { render, staticRenderFns } from "./ManagerList.vue?vue&type=template&id=b4ff28fc"
import script from "./ManagerList.vue?vue&type=script&lang=js"
export * from "./ManagerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports